import React, { useEffect, useState } from 'react'
import '../styles/contactus.css'
import Envelope from '../assets/icons/Envelope.png'
import Phone from '../assets/icons/Phone.png'
import Location from '../assets/icons/Location.png'
import Amalgam from '../assets/images/Amalgam-logo.png'
import Swirl from '../assets/images/Swirl.png'
import Writing from '../assets/images/Writing.png'
import Teamwork from '../assets/images/Teamwork.png'
import Facebook from '../assets/images/Facebook.png'
import Instagram from '../assets/images/Instagram.png'
import X from '../assets/images/X.png'
import LinkedIn from '../assets/images/LinkedIn.png'
import Youtube from '../assets/images/Youtube.png'
import { Link, useLocation, useNavigate } from "react-router-dom";
import Placeholder from '../assets/images/Placeholder.png'
import sendEmail from '../utils/sendEmail'
import { useMediaQuery } from 'react-responsive';
import Arrow from '../assets/images/Arrow1.png'
function ContactUs() {
  
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isMobile = useMediaQuery({ maxWidth: 570 });
  const isTablet = useMediaQuery({ maxWidth: 1100 });
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isChecked, setIsChecked] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};

    if (!name.trim()) {
      newErrors.name = 'Name is required';
    }

    if (!email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = 'Please enter a valid email';
    }

    if (!message.trim()) {
      newErrors.message = 'Message is required';
    }

    if (!isChecked) {
      newErrors.terms = 'You must agree to the Terms';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSendEmail = async () => {
    if (validateForm()) {
      const result = await sendEmail(name, email, message);
      if (result.success) {
        alert('Email sent successfully!');
        // Clear form after successful submission
        setName('');
        setEmail('');
        setMessage('');
        setIsChecked(false);
      } else {
        alert(`Failed to send email: ${result.error}`);
      }
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top
  }, [pathname]);

  return (
    <div style={{ position: "relative", zIndex: 1 , backgroundColor: "white"}}>

      <div style={{ position: "relative" }}>
        <section className='contactus-row-1'>
          <img src={Swirl} alt="Swirl" className='swirl' />
          <div>
            <h1>Let's talk!</h1>
            <p>We're here to help. Contact us for any inquiries or support.</p>
          </div>
        </section>

        <section className='contactus-row-2'>
          <img src={Writing} alt="Swirl" className='contactus-blobert' />
          <form>
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            {errors.name && <span className="error-message">{errors.name}</span>}

            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {errors.email && <span className="error-message">{errors.email}</span>}

            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="comments"
              value={message}
              placeholder="Enter your message"
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>
            {errors.message && <span className="error-message">{errors.message}</span>}

            <div className='contactus-label'>
              <input
                type="checkbox"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
              />
              <p>I agree to the Terms</p>
            </div>
            {errors.terms && <span className="error-message">{errors.terms}</span>}

            <button onClick={(e) => { e.preventDefault(); handleSendEmail() }}>Get in touch</button>
          </form>
        </section>
      </div>

      <section className='contactus-row-3'>
        <div className='contactus-row-3-header'>
          <p>Want to reach out?</p>
          <h2>Here's our contact information</h2>
        </div>

        <div className='contactus-row-3-contact'>
          <div>
            <img src={Envelope} />
            <h3>Email</h3>
            <p>hello@amalgam-inc.com</p>
          </div>
          <div>
            <img src={Phone} />
            <h3>Phone</h3>
            <p>+1 484-354-8498</p>
          </div>
          <div>
            <img src={Location} />
            <h3>Headquartered At</h3>
            <p>851 Duportail Road, 2nd Floor, Chesterbrook, PA 19087
            </p>
          </div>
        </div>
      </section>

   <section className='ourwork-row-14 blog-row-14'>

                <h2>Get in touch</h2>
                <p>Reach out to us to gather more information or <br className='blog-row-14-break' />  set our wheels in motion.</p>
                <div className='ourwork-arrow-box blog-arrow-box'>
                    <img src={Arrow} alt="arrow" className='ourwork-arrow' />
                    <button onClick={() => navigate("/contactus")}>Let's talk</button>
                </div>

            </section>

      {!isTablet ? (
        <section className='home-footer'>
          <div className='home-footer-middle'>
            <img src={Amalgam} alt="Amalgam" className='home-footer-amalgam' />
            <Link to="/" className='home-footer-links'>Home</Link>
            <Link to="/ourwork" className='home-footer-links'>Our Work</Link>
            <Link to="/aboutus" className='home-footer-links'>About Us</Link>
            <Link to="/case-studies" className='home-footer-links'>Case Studies</Link>
            <Link to="/startups" className='home-footer-links'>Launchpad</Link>
            <Link to="/careers" className='home-footer-links'>Careers</Link>
            <Link to="/contactus" className='home-footer-links'>Contact Us</Link>
            <img src={LinkedIn} alt="Instagram" className='home-footer-linkedin' />
          </div>
          <div className='home-footer-dividor'>
            <div className='home-footer-policies'>
              <p><Link to="/privacy-policy">Privacy Policy</Link></p>
              <p><Link to="/terms-and-conditions">Terms and Conditions</Link></p>
              <p><Link to="/cookie-policy">Cookie Policy</Link></p>
            </div>
          </div>
        </section>
      ) : (
        <section>
          <div className="footer-minimal">
            <div className="footer-content">
              {/* <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px' }}>
                <img src={Amalgam} alt="Amalgam" className="footer-logo" />
                <img src={LinkedIn} alt="Instagram" className='home-footer-linkedin' style={{ alignSelf: "center" }} />
              </div> */}
              <div className="footer-top-row">
                <Link to="/" className="footer-link">Home</Link>
                <span className="footer-separator">•</span>
                <Link to="/ourwork" className="footer-link">Our Work</Link>
                <span className="footer-separator">•</span>
                <Link to="/aboutus" className="footer-link">About Us</Link>
                <span className="footer-separator">•</span>
                <Link to="/case-studies" className="footer-link">Case Studies</Link>
              </div>
              <div className="footer-bottom-row">
                <Link to="/startups" className="footer-link">Launchpad</Link>
                <span className="footer-separator">•</span>
                <Link to="/careers" className="footer-link">Careers</Link>
                <span className="footer-separator">•</span>
                <Link to="/contactus" className="footer-link">Contact</Link>
              </div>
            </div>
          </div>

          <div style={{
            width: "80%",
            height: "0px",
            borderTop: "1px solid black",
            backgroundColor: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingBottom: "20px",
            margin: "0 auto"
          }}>
          </div>
          <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "white",
            gap: isMobile ? "5px" : "20px",
            paddingBottom: "20px",
            width: "100%",
            padding: "0 10px 20px 10px",
            textAlign: "center"
          }}>
            <Link to="/privacy-policy" style={{ textAlign: "center", color: "black", textDecoration: "none" }}>Privacy Policy</Link>
            <span style={{ color: "black", fontSize: "14px" }}>|</span>
            <Link to="/terms-and-conditions" style={{ color: "black", textDecoration: "none" }}>Terms and Conditions</Link>
            <span style={{ color: "black", fontSize: "14px" }}>|</span>
            <Link to="/cookie-policy" style={{ fontSize: "14px", color: "black", textDecoration: "none" }}>Cookie Policy</Link>
          </div>
        </section>
      )}

    </div>
  )
}

export default ContactUs